//记得在 src\components\lang\zhLoad.js 里面添加对象
const pointsStatistics = {
  areaName: '区域名称',
  unbindCount: '未绑定微信人数',
  clockInCount: '打卡门店不为0人数',
  unClockInCount: '打卡门店为0人数',
  totalCount: '总人数',
  registrationRate: '注册率',
  participationRate: '参与率',
  msg: {}
};
export default pointsStatistics



// WEBPACK FOOTER //
// ./src/page/dataManagement/pointsStatistics/lang/pointsStatistics.zh.js